module.exports = __webpack_public_path__ + "static/media/wide.5f254b89.jpg";